import { Screen } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/register-stripe-screen';
import { useAuth } from '@fans-fund-me/shared-common-esm-authentication';
import { useState } from 'react';
import { createStripeAccount } from '../../api/payments.ts';

function RegisterStripe() {
  const auth = useAuth();

  const [isLoading, setIsLoading] = useState(false);

  const handleClick = () => {
    setIsLoading(true);
    createStripeAccount(auth.token, {
      refreshUrl: `${import.meta.env.VITE_STRIPE_REDIRECT}/${auth.details.username}`,
      returnUrl: `${import.meta.env.VITE_STRIPE_REDIRECT}/${auth.details.username}`,
    })
      .then((response) => {
        setIsLoading(false);
        location.href = response.data.url;
      })
      .catch((error) => {
        console.error('Error sending user to Stripe', JSON.stringify(error));
        setIsLoading(false);
      });
  };

  return <Screen handleClick={handleClick} isLoading={isLoading} />;
}

export default RegisterStripe;
